module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (41).a67fbbc3.png";